import React, {useState} from 'react';
import { RouteComponentProps } from "@reach/router";
import { Map } from './Map';
import { useSelector } from 'react-redux';
import { selectAllPositions } from '../../../store/positions/positionsSlice';
import { selectAllsites } from '../../../store/positions/sitesSlice';
import { selectMapSettings } from '../../../store/devices/mapSettingsSlice';
import { isJsonEqual } from '../../../lib/typeCheck';
import styled from 'styled-components';
import { PowerSingleSelectPositionMenu } from '../../positions-menu/PowerSingleSelectPositionsMenu';
import Icon from '@iconify/react';
import chevronLeft from '@iconify/icons-carbon/chevron-left';
import chevronRight from '@iconify/icons-carbon/chevron-right';
import { Detailbar } from './Detailbar';

type PositionMapsProps = RouteComponentProps & {
  features: any;
  fullscreen: any;
  children?: React.ReactNode;
}

const StyledSingleDevices = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

const SidebarContainer = styled.div<{ isOpen: boolean }>`
  /* Sidebar container styles */
    margin-left: 0px;
    width: ${props => (props.isOpen ? '20vw' : '0')};
    height: 100%;
    background: #FFF;
    border-right: 1px solid #AAA;
    overflow-y: scroll;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
`;

const ToggleButton = styled.button<{ isOpen: boolean }>`
  /* Button styles */
  background-color: #FFFFFF;
  border: none;
  color: #233567;
  padding: 10px 4px 10px 2px;
  text-align: center;
  text-decoration: none;
  display: block;
  font-size: 24px;
  cursor: pointer;

  border-top-left-radius: 0px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 50px;

  position: absolute;
  top: 50%;
  left: ${props => (props.isOpen ? '20vw' : '0')};
  z-index: 1;

  &:hover{
    background: #233567;
    color: #FFFFFF;
  }
`;

const SidebarToggleButton = ({ isOpen, toggleSidebar }: { isOpen: boolean; toggleSidebar: () => void }) => {
  return (
    <ToggleButton onClick={toggleSidebar} isOpen = {isOpen}>
      <Icon icon={isOpen ? chevronLeft : chevronRight} style={{fill: "#D0D3D9", zIndex: 2, display: "flex", margin: "4px"}}/>
    </ToggleButton>
  );
};

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <SidebarToggleButton isOpen={isOpen} toggleSidebar={toggleSidebar} />
      <SidebarContainer isOpen={isOpen}>
        {/* Sidebar content */}
        <PowerSingleSelectPositionMenu/>
      </SidebarContainer>
    </div>
  );
};

export const PositionMap = (props: PositionMapsProps) => {
  
  const positions = useSelector(selectAllPositions, isJsonEqual) || [];
  const sites = useSelector(selectAllsites, isJsonEqual) || [];
  const mapSettings = useSelector(selectMapSettings, isJsonEqual);
  
  return (
    <StyledSingleDevices>
      <Sidebar/>
      {/* <Detailbar positions={positions}/> */}
      <Map mapSettings={mapSettings} positions={positions} sites={sites}  features={props.features} fullscreen={props.fullscreen}/>
    </StyledSingleDevices>
  )
}
